import request from "@/utils/request"
// 获取设备枪列表
export function getChargeGunPageList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargeGun/GetPageList",
    method: "get",
    params
  })
}
// 修改设备枪
export function modifyChargeGun(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargeGun/Update",
    method: "post",
    data
  })
}
// 删除设备枪
export function delChargeGun(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargeGun/Delete",
    method: "post",
    data
  })
}
// 新增设备枪
export function addChargeGun(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargeGun/Add",
    method: "post",
    data
  })
}
// 获取站点信息
export function GetOrgPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/MainDbArchvie/GetOrgPageList",
    method: "post",
    data
  })
}

// 获取三元信息
export function GetTripletPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/MainDbArchvie/GetTripletPageList",
    method: "post",
    data
  })
}
//获取桩列表
export function getPowerChargePileList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargePile/GetPageList",
    method: "get",
    params
  })
}
//获取jng桩列表
export function GetJngPilePageList(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargePile/GetJngPilePageList",
    method: "get",
    params
  })
}
//获取运行日志列表
export function GetPageListLog(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevRunLog/GetPageList?t=837d",
    method: "post",
    data
  })
}
//获取在线数据列表
export function getOnlinePageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetOnlinePageList",
    method: "post",
    data
  })
}
//获取在线数据统计
export function GetOnlineStatistic(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetOnlineStatistic",
    method: "post",
    data
  })
}
//获取资产码列表
export function GetOn_OfflinePageList(data) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetOn_OfflinePageList",
    method: "post",
    data
  })
}
//获取设备状态详情数据
export function GetDevExtInfo(params) {
  return request({
    url: "/Anno.Plugs.DevRun/DevDataView/GetDevExtInfo",
    method: "get",
    params
  })
}
//获取站点列表
export function getPowerSiteList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSite/GetPageList",
    method: "post",
    data
  })
}
//刷新站点
export function freshPowerSite(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSite/Fresh",
    method: "post",
    data
  })
}
//删除站点
export function delPowerSite(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSite/Delete",
    method: "post",
    data
  })
}
//新增站点
export function addPowerSite(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerSite/Add",
    method: "get",
    params
  })
}
// 获取未切换的站点Page列表
export function GetOrgForIpSPageList(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/MainDbArchvie/GetOrgForIpSPageList",
    method: "post",
    data
  })
}
//获取站点列表
export function GetSendOrderLogPageList(data) {
  return request({
    url: "Anno.Plugs.DevRun/DevDataView/GetSendOrderLogPageList",
    method: "post",
    data
  })
}

//解除指定设备占用
export function unlockDeviceApi(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/MainDbArchvie/UnlockDevice",
    method: "get",
    params
  })
}

//获取三元信息列表数据
export function getTripletPageListApi(data) {
  return request({
    url: "/Anno.Plugs.DevArchive/MainDbArchvie/GetTripletPageList",
    method: "post",
    data
  })
}

//修改三元信息协议类型
export function updateTripletProtocolTypeApi(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/MainDbArchvie/UpdateTripletProtocolType",
    method: "get",
    params
  })
}

// 获取三元详情
export function GetTripletByAssetsCode(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/Triplet/GetTripletByAssetsCode",
    method: "get",
    params
  })
}
//查找站点
export function GetPageListForAdd(params) {
  return request({
    url: "/Anno.Plugs.DevArchive/PowerChargePile/GetPageListForAdd",
    method: "get",
    params
  })
}
